import { To, useNavigate } from 'react-router-dom';
import { useLocationWithState } from './useLocationWithState';
import {
  NavigateFunctionWithState,
  NavigateOptionsWithState,
} from '../appTypings';
import { useCallback } from 'react';

/**
 * Use this instead of the hook exported from 'react-router-dom'.
 */
export function useNavigateWithHistory(): NavigateFunctionWithState {
  const navigate = useNavigate();
  const location = useLocationWithState();

  const navigateCb = useCallback(navigate, [navigate]);

  return useCallback(
    (toOrDelta: To | number, options?: NavigateOptionsWithState) => {
      if (typeof toOrDelta === 'number') {
        navigateCb(toOrDelta);
      } else {
        navigateCb(toOrDelta, {
          ...options,
          state: {
            ...options?.state,
            from: location ?? {
              pathname: '/',
            },
          },
        });
      }
    },
    [location, navigateCb]
  );
}
